import { Point, Sprite, Texture } from 'pixi.js';
import { TweenMax, Back, Power1 } from 'gsap';

export default class DarkCloud extends Sprite {
  initPos: Point;
  isVisible = false;
  constructor(textureName: string, posX: number, posY: number) {
    super(Texture.from(textureName));

    // vars
    this.initPos = new Point(posX, posY);

    // props
    this.alpha = 0;
    this.anchor.set(0.5);
    this.x = posX;
    this.y = posY;
  }

  // --------------------------------------------------------------
  // Show
  // --------------------------------------------------------------

  show(value: boolean): void {
    if (this.isVisible !== value) {
      this.isVisible = value;

      TweenMax.killTweensOf(this);
      TweenMax.killTweensOf(this.scale);
      if (this.isVisible) {
        const animTime = 0.2 + Math.random() * 0.4;
        const delay = Math.random() * 0.3;
        TweenMax.to(this, animTime, { alpha: 1, ease: Power1.easeInOut, delay });

        this.scale.set(0.7);
        TweenMax.to(this.scale, animTime, {
          x: 1,
          y: 1,
          ease: Back.easeOut,
          delay,
          onComplete: this.moveStep.bind(this),
        });
      } else {
        TweenMax.to(this, 0.3, { alpha: 0, ease: Power1.easeInOut });
      }
    }
  }

  moveStep(): void {
    TweenMax.to(this, 3 + Math.random(), {
      x: this.initPos.x - 10 + Math.random() * 20,
      y: this.initPos.y - 10 + Math.random() * 20,
      ease: Power1.easeInOut,
      onComplete: this.moveStep.bind(this),
    });
  }
}
